<script lang="ts">
	interface Props {
		title: string;
		description: string;
		url: string;
		image?: string;
	}

	let { title, description, url, image = '/images/2025LGLogo.png' }: Props = $props();

	// Ensure absolute URLs for social media
	const absoluteUrl = url.startsWith('http') ? url : `https://locallygrown.net${url}`;
	const absoluteImage = image.startsWith('http') ? image : `https://locallygrown.net${image}`;
</script>

<svelte:head>
	<!-- Canonical URL -->
	<link rel="canonical" href={absoluteUrl} />

	<!-- Open Graph / Social Media -->
	<meta property="og:type" content="website" />
	<meta property="og:url" content={absoluteUrl} />
	<meta property="og:title" content={title} />
	<meta property="og:description" content={description} />
	<meta property="og:image" content={absoluteImage} />

	<!-- Twitter Card -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content={title} />
	<meta name="twitter:description" content={description} />
	<meta name="twitter:image" content={absoluteImage} />
</svelte:head>
